import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX, ZTime } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XDiv, XIconButton, XText, XTooltip } from "IZOX/_X";
import { MdOutlineArrowRightAlt } from "react-icons/md";
import PolicyUtils from "../_utils/PolicyUtils";
import { HiDownload } from "react-icons/hi";
import { TbFileUpload, TbReceipt } from "react-icons/tb";
import { QFCheckBox } from "IZOX/BLOCKS/Libs/QForm/_gears";
import _ from "lodash";

/**
 * @augments {Component<Props, State>}
 */
class PolicyRowM extends Component {

  static propTypes = {
    policyDoc: PropsType.any,
    onViewDetailPress: PropsType.func,
    onDownload: PropsType.func,
    onUpload: PropsType.func,
    onReceipt: PropsType.func,
    onRenew: PropsType.func,
    checked: PropsType.bool,
    onCheck: PropsType.func
  }

  static defaultProps = {
    policyDoc: {},
    onViewDetailPress: null,
    onDownload: null,
    onUpload: null,
    onReceipt: null,
    onRenew: null,
    checked: false,
    onCheck: null
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PolicyRowM.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  renderVertBox(label, value, style, containerStyle){
    return (
      <VStack width={120} HAlign="[" mH={5} style={containerStyle}>
        <HStack HAlign="[" fitWidthToContent>
          <XText color={ColorX.CSS("Gray4")} fullWidth
            fontSize={12}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <HStack HAlign="[" fitWidthToContent>
          <XText color={ColorX.CSS("Stone")} fontSize={13} width={90} bold
            style={style} ellipsisMode="ellipsis">
            {LocaleX.Parse(value)}
          </XText>
        </HStack>
      </VStack>
    );
  }

  render(){
    let {policyDoc, onViewDetailPress, onUpload, onRenew, onReceipt, 
      onDownload, checked, onCheck, isDashboard, isRenew} = this.props;  
    let {policyNo, _client, _maid, _dCustomer,
      createdAt, startAt, endAt, runtimeStatus,
      packageDoc, policyDuration} = policyDoc;
    let _status = PolicyUtils.GetStatus(runtimeStatus);

    let planStr = `${policyDuration} ${policyDuration === 1 ? "year" : "years"}${_.isEmpty(packageDoc?.shortName) ? "" : ` + ${packageDoc?.shortName}`}`;

    return (
      <VStack fullWidth>
        <HStack bgColor={ColorX.CSS(_status.color)} 
          spacing={10} HAlign="[" pV={10} pH={15}>
          <HStack spacing={5} HAlign="[">
            {onCheck &&
              <QFCheckBox name="checked" _onChange={onCheck} formValue={{checked}} size={14}/>}
            <XText color={ColorX.CSS("pureWhite")} bold fontSize={14}>
              {LocaleX.Parse({
                EN: "Policy no.",
                TC: "保單編號"
              })}
            </XText>
            <XText color={ColorX.CSS("pureWhite")} bold fontSize={14}>
              {policyNo}
            </XText>
          </HStack>
          <Spacer/>
          {onDownload &&
            <XTooltip tooltip={LocaleX.Parse({
              EN: "Download",
              TC: "下載"
            })}>
              <XIconButton onPress={onDownload} padding={5} size={24}
                bgColor={ColorX.CSS("ActiveBg")}>
                <HiDownload color={ColorX.CSS("Active")}/>
              </XIconButton>
            </XTooltip>}
          {onUpload &&
            <XTooltip tooltip={LocaleX.Parse({
                EN: "Upload document",
                TC: "上傳文件"
              })}>
              <XIconButton onPress={onUpload} padding={5} size={24}
                bgColor={ColorX.CSS("RenewedBg")}>
                <TbFileUpload color={ColorX.CSS("Renewed")}/>
              </XIconButton>
            </XTooltip>}
          {onReceipt &&
            <XTooltip tooltip={LocaleX.Parse({
                EN: "Upload receipt",
                TC: "上傳收據"
              })}>
              <XIconButton onPress={onReceipt} padding={5} size={24}
                bgColor={ColorX.CSS("BgAxit")}>
                <TbReceipt color={ColorX.CSS("Axit")}/>
              </XIconButton>
            </XTooltip>}
        </HStack>
        <HStack bgColor={ColorX.CSS("pureWhite")} VAlign="^" p={8}>
          <VStack fullWidth spacing={20}>
             <HStack>
              {this.renderVertBox({
                EN: "Policy Holder",
                TC: "保單持有人"
              }, _client?.meta?.fullName ?? _dCustomer?.meta?.fullName)}
              {this.renderVertBox({
                EN: "Insured Person",
                TC: "被保險人"
              }, _maid?.fullName)}
            </HStack>
            <HStack>
              {this.renderVertBox({
                EN: "Plan",
                TC: "計劃"
              }, planStr)}
              {this.renderVertBox({
                  EN: "Applied date",
                  TC: "申請日期"
                }, createdAt ? ZTime.Moment(createdAt).format("DD/MM/YYYY") : "----")}
            </HStack>
            <HStack>
              {this.renderVertBox({
                EN: "Effective date",
                TC: "生效日期"
              }, startAt ? ZTime.Moment(startAt).format("DD/MM/YYYY") : "----")}
              <VStack width={16} VAlign="_">
                <XDiv mT={22}>
                  <MdOutlineArrowRightAlt color={ColorX.CSS("Axit")}/>
                </XDiv>
              </VStack>
              {this.renderVertBox({
                EN: "Expired date",
                TC: "失效日期"
              }, endAt ? ZTime.Moment(endAt).format("DD/MM/YYYY") : "----")}
            </HStack>
          </VStack>
          <VStack width={100} HAlign="]">
            <HStack bgColor={_status.bgColor}>
              <XText color={_status.color} textAlign="|" 
                fontSize={13} fullWidth>
                {LocaleX.Parse(_status.label)}
              </XText>
            </HStack>
            <XButton notInjectColor onPress={isRenew ? onRenew : onViewDetailPress} padding={0} pV={2}>
              <HStack>
                <XText fontSize={12} color={ColorX.CSS("Axit")} style={{textDecoration: "underline"}}>
                  {LocaleX.Parse(
                    isDashboard ? 
                    {
                      EN: "Receipts",
                      TC: "收據"
                    } : (isRenew ? 
                      {
                        EN: "Renew",
                        TC: "更新"
                      } :
                      {
                        EN: "View Details",
                        TC: "顯示詳細資料"
                      }))}
                </XText>
              </HStack>
            </XButton>
          </VStack>
        </HStack>
      </VStack>
    );
  }

}

export default observer(PolicyRowM);
